export default "__VITE_PUBLIC_ASSET__d06d78ed__"